import { render, staticRenderFns } from "./news_sh.vue?vue&type=template&id=39392ae6&scoped=true&"
import script from "./news_sh.vue?vue&type=script&lang=js&"
export * from "./news_sh.vue?vue&type=script&lang=js&"
import style0 from "./news_sh.vue?vue&type=style&index=0&id=39392ae6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39392ae6",
  null
  
)

export default component.exports